export const scheduleB = (contractor: any) => {
  return [
    { text: 'SCHEDULE B', style: 'h2' },

    { text: 'RATES', style: 'p', bold: true },

    { text: [
        { text: 'Company agrees to compensate Independent Contractor for the ', },
        { text: 'TICA Services', bold: true },
        { text: ' under this Agreement, at the rate applicable to each daily shipment as available to Independent Contractor from Company’s Dispatch Office prior to each Shipment accepted by Independent Contractor.' },
      ], style: 'p' },

    { text: 'OTHER', style: 'p', bold: true },

    { text: [
        { text: 'Any other compensation will be at a', },
        { text: 'mutually agreed upon rate', bold: true },
        { text: ' between the Company and the Independent Contractor.' },
      ], style: 'p' },

    {
      columns: [
        {
          width: '50%',
          text: [
            { text: 'COMPANY:', bold: true, color: '#058ff4' },
            { text: '\n' },
            { text: 'Sierra Expediting Inc.', bold: true },
            { text: '\n' },
            { text: 'By: ', bold: true },
            { text: '_______________________ (Authorized Signature)' },
            { text: '\n' },
            { text: 'Print Name: ', bold: true },
            { text: '_____________________________________' },
            { text: '\n' },
            { text: 'Title: ', bold: true },
            { text: '____________________________________________' },
            { text: '\n' },
            { text: 'Date: ', bold: true },
            { text: '____________________________________________' },
            { text: '\n' },
          ],
        },

        {
          width: '50%',

          text: [
            { text: 'INDEPENDENT CONTRACTOR:', bold: true, color: '#058ff4' },
            { text: '\n' },
            { text: `${contractor.name}`, bold: true },
            { text: '\n' },
            { text: 'By: ', bold: true },
            { text: '_______________________ (Authorized Signature)' },
            { text: '\n' },
            { text: 'Print Name: ', bold: true },
            { text: '_____________________________________' },
            { text: '\n' },
            { text: 'Title: ', bold: true },
            { text: '____________________________________________' },
            { text: '\n' },
            { text: 'Date: ', bold: true },
            { text: '____________________________________________' },
            { text: '\n' },
          ],

        },
      ],
      style: 'p',
    },
  ]
}